export default function insertBlock(editor) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      type = _ref.type,
      data = _ref.data;

  return editor.splitBlock().moveToEndOfPreviousBlock().setBlocks({
    type: type || 'unstyled',
    data: data || {}
  }).moveToStartOfNextBlock();
}